/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { StyleSheet } from 'react-native';
import { TwTheme } from '@tw/tw-runtime-rn';
const theme = TwTheme.values;

export const styles = StyleSheet.create({
  container: {
    flex: 1
  },
  contentContainer: {
    // paddingHorizontal: theme.spaces[4],
    paddingVertical: theme.spaces[2],
    flex: 1
  },
  list: {
    flex: 1
  },
  goodCard: {
    paddingVertical: theme.spaces[1]
  },
  iconBorder: {
    borderWidth: 1,
    borderColor: theme.primaryColors.base,
    height: 32,
    width: 32
  },
  image: {
    height: 146
  },
  subtitle: {
    // TODO:增加主题规范
    color: '#F19D4F',
    fontWeight: theme.textWeights.bold,
    ...theme.textSizes.sm
  },
  subtitleTag: {
    lineHeight: 13,
    fontSize: 10,
    borderWidth: 1,
    borderColor: '#A4A4A4',
    color: '#A4A4A4',
    borderRadius: 2,
    paddingHorizontal: 4,
    alignItems: 'center'
  },
  cartFooter: {
    backgroundColor: 'white',
    paddingHorizontal: 16,
    paddingVertical: 12
  },
  addToCartHeader: {
    padding: 12,
    paddingBottom: 0,
    color: theme.textColors.secondary
  },
  notifyBarContainer: {
    paddingVertical: 0
  },
  confirmButton: {
    margin: 10
  },

  // Filter
  headerContainer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: 20,
    flex: 1
  },
  headerTitle: {
    ...theme.textSizes.sm, //16
    color: '#8E8E8E'
  }
});
